import Vue from 'vue';
import Catalog from './App.vue';
import Buefy from 'buefy';

Vue.use(Buefy,{
    defaultIconPack: 'fas',
})

if(document.getElementById("catalogApp")){
    new Vue({
        render: h => h(
            Catalog, {
                props: {
                    productListEndpoint: document.getElementById("catalogApp")
                        .getAttribute("product-list-endpoint"),
                    categoryListEndpoint: document.getElementById("catalogApp")
                        .getAttribute("category-list-endpoint"),
                    subcategoryListEndpoint: document.getElementById("catalogApp")
                        .getAttribute("subcategory-list-endpoint"),
                    productDetailEndpoint:document.getElementById("catalogApp")
                        .getAttribute("product-detail-endpoint"),
                    subcategoryDetail:document.getElementById("catalogApp")
                        .getAttribute("subcategory-detail"),
                    createProduct:document.getElementById("catalogApp")
                        .getAttribute("create-product"),
                    productDelete:document.getElementById("catalogApp")
                        .getAttribute("product-delete"),
                    categoryDetailUrl: document.getElementById("catalogApp")
                        .getAttribute("category-detail"),
                    subcategoryListAll: document.getElementById("catalogApp")
                        .getAttribute("subcategory-list-all"),
                    exportProducts: document.getElementById("catalogApp")
                        .getAttribute("export-products"),
                    filtersListCreate: document.getElementById("catalogApp")
                        .getAttribute("filters-list-create"),
                    filtersDetail: document.getElementById("catalogApp")
                        .getAttribute("filters-detail"),
                    filterOptionDetail: document.getElementById("catalogApp")
                        .getAttribute("filter-option-detail"),
                    filterOptionListCreate: document.getElementById("catalogApp")
                        .getAttribute("filter-option-list-create"),
                    csrfToken:document.getElementById("catalogApp")
                        .getAttribute("csrf-token"),
                    importUrl:document.getElementById("catalogApp")
                        .getAttribute("import-url"),

                }
            }
        )
    }).$mount("#catalogApp")
}
